<script lang="ts">
    /* eslint-disable no-undef-init */
    import type { ValueEditorTypeOrAlias} from '../types';
    import type {ValueEditorSize} from '../types';
    import type {FormController, FormControlOptions} from '../internal/forms/types';
    import type {ValueEditorOptions, ValueEditorValidations} from '../kp-value-editor/types';
    import type {ValueEditorLocalizations} from '../localizations/types';
    import KpValueEditorForceSettings from './KpValueEditorForceSettings.svelte';
    import type {ForceSetting} from './types';
    import KpValueEditor from '../kp-value-editor/KpValueEditor.svelte';

    type MODEL_VALUE = $$Generic;

    export let forceSettings: ForceSetting[];

    export let type: ValueEditorTypeOrAlias;
    export let model: MODEL_VALUE;
    export let formControlOptions: FormControlOptions | null = undefined;
    export let editorId: string = undefined;
    export let editorName: string = undefined;
    export let placeholder: string = undefined;
    export let isDisabled: boolean = undefined;
    export let isVisible: boolean = undefined;
    export let isFocused: boolean = undefined;
    export let forceShowErrors: boolean = undefined;
    export let size: ValueEditorSize = undefined;
    export let options: ValueEditorOptions = undefined;
    export let validations: ValueEditorValidations = undefined;
    export let localizations: ValueEditorLocalizations = undefined;

    let componentRef;

    export function getFormController(): FormController<any> {
        return componentRef.getFormController();
    }
</script>

<template>
    <KpValueEditorForceSettings {forceSettings}>
        <KpValueEditor {type}
                       {model}
                       {formControlOptions}
                       {editorId}
                       {editorName}
                       {placeholder}
                       {isDisabled}
                       {isVisible}
                       {isFocused}
                       {forceShowErrors}
                       {size}
                       {options}
                       {validations}
                       {localizations}

                       on:model-change
                       bind:this={componentRef}/>
    </KpValueEditorForceSettings>
</template>
